import type { ReactElement } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/shadcn/tooltip";

export const NAV_TIP_DELAY = 300;

type HeaderTipProps = {
  label: string;
  children: ReactElement;
  side?: "top" | "right" | "bottom" | "left";
  delayDuration?: number;
};

export const HeaderTip = ({ label, children, side = "bottom", delayDuration = 800 }: HeaderTipProps) => (
  <TooltipProvider delayDuration={delayDuration} skipDelayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side={side}
        sideOffset={8}
        data-testid="header-tip"
        className="rounded-md border-0 bg-(--layout-brand) px-2.5 py-1 text-xs font-medium text-white shadow-lg ring-1 ring-white/20"
      >
        {label}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
